import { render, staticRenderFns } from "./InventoryView.vue?vue&type=template&id=a31f836c&scoped=true"
import script from "./InventoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./InventoryView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InventoryView.vue?vue&type=style&index=0&id=a31f836c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31f836c",
  null
  
)

export default component.exports